/* eslint-disable max-len */
export const Constants = {
  associateWorkOrder: 'Associar OS por matrícula',
  foundWorkOrders:
    'Foram encontradas OS anteriores para este imóvel. Você pode associar esta OS a uma anterior para manter o histórico unificado.',
  registry: 'Matrícula:',
  createdAt: 'data de criação:',
  evaluatedValue: 'valor avaliado:',
  evaluationType: 'tipo de cálculo:',
  reportType: 'tipo de relatório:',
  dontAssociate: 'não associar',
  associate: 'associar OS',
  approve: 'aprovar',
  cancel: 'cancelar',
};
